import React, { useMemo } from "react";

interface Star {
  className: string;
  left: string;
  top: string;
  animationDuration: string;
  animationDelay: string;
}

export interface ShootingStar {
  id: number;
  left: number;
  top: number;
  rotation: string;
  distance: string;
}

interface Props {
  shootingStars?: ShootingStar[];
}

const STAR_COUNT = 240;

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

const createLivingStarfield = (count = STAR_COUNT, reduceMotion = false) => {
  const stars: Star[] = [];

  for (let i = 0; i < count; i += 1) {
    const sizeRoll = Math.random();
    let className = sizeRoll < 0.34 ? "s2" : sizeRoll < 0.67 ? "s1" : "s3";

    if (Math.random() < 0.08) {
      className = "b";
    }

    if (!reduceMotion) {
      const flickerRoll = Math.random();

      if (flickerRoll < 0.4) {
        className += " tw";
      } else if (flickerRoll < 0.72) {
        className += " dm";
      }
    }

    stars.push({
      className,
      left: `${(Math.random() * 100).toFixed(1)}%`,
      top: `${(Math.random() * 100).toFixed(1)}%`,
      animationDuration: `${(2.8 + Math.random() * 3.4).toFixed(1)}s`,
      animationDelay: `${(Math.random() * 5).toFixed(1)}s`,
    });
  }

  return stars;
};

const HomeSky: React.FC<Props> = ({ shootingStars = [] }) => {
  const stars = useMemo(
    () => createLivingStarfield(STAR_COUNT, prefersReducedMotion()),
    [],
  );

  return (
    <div className="home-sky" id="homeSky" aria-hidden="true">
      {stars.map((star, index) => (
        <span
          key={index}
          className={`star ${star.className}`}
          style={{
            left: star.left,
            top: star.top,
            animationDuration: star.animationDuration,
            animationDelay: star.animationDelay,
          }}
        />
      ))}
      {shootingStars.map((star) => {
        const style = {
          left: `${star.left}px`,
          top: `${star.top}px`,
          "--rot": star.rotation,
          "--dist": star.distance,
        } as React.CSSProperties & Record<string, string>;

        return (
          <span
            key={star.id}
            className="shoot go"
            style={style}
            aria-hidden="true"
          />
        );
      })}
    </div>
  );
};

export default HomeSky;
